import type { ModalPropTypes } from './ShareProgress.types';
import type { ReactElement } from 'react';

import { Flex } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog } from '../../Dialog';

import { ShareProgressContent } from './ShareProgressContent';
import { ShareProgressSocial } from './ShareProgressSocial';

export function ShareProgressModal(props: ModalPropTypes): ReactElement {
  const { open, onClose } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onClose();
        }
      }}
      width="large"
      idPrefix="profile-page-share-progress-modal"
      title={t('Share your progress')}
      description={t('Share your current Rango rank and score directly on your X.')}
    >
      <Flex direction="column" gap="5" width="100%">
        <ShareProgressContent />
        <ShareProgressSocial />
      </Flex>
    </Dialog>
  );
}
